import React, {
  useEffect,
  useContext,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import ContractModalContext, { initialValues } from '../../../../../../ContractModal/context/ContractModalContext';
import ContractEditor from '../../../../../../ContractModal/ContractEditor';
import LoadingOverlay from '../../../../../../LoadingOverlay';
import useComponentMounted from '../../../../../../../../hooks/useComponentMounted';

import {
  EmptyStateContainer,
  StyledModalContent,
} from './styles';
import texts from './texts.json';

const LeadModalContract = ({ lead, showPostCommitmentConfiguration, isSDRChat }) => {
  const [isInitialContractLookupComplete, setIsInitialContractLookupComplete] = useState(false);
  const isComponentMountedRef = useComponentMounted();
  const {
    setCoachId,
    loadContractByLead,
    isLoading,
    setContractType,
    contractDoc,
  } = useContext(ContractModalContext);

  useEffect(() => {
    setContractType(initialValues.contractType);
  }, [setContractType]);

  useEffect(() => {
    const loadContractData = async () => {
      if (lead?.coach) {
        setCoachId(lead.coach);
      }

      if (!lead?.id) {
        if (isComponentMountedRef.current) {
          setIsInitialContractLookupComplete(true);
        }
        return;
      }

      setIsInitialContractLookupComplete(false);
      try {
        await loadContractByLead(lead);
      } finally {
        if (isComponentMountedRef.current) {
          setIsInitialContractLookupComplete(true);
        }
      }
    };

    loadContractData();
  }, [
    lead,
    setCoachId,
    loadContractByLead,
    isComponentMountedRef,
  ]);

  const shouldShowBlockingLoader = isLoading || !isInitialContractLookupComplete;
  const shouldShowNoContractMessage = !shouldShowBlockingLoader && isSDRChat && !contractDoc;

  return (
    <StyledModalContent>
      {shouldShowNoContractMessage ? (
        <EmptyStateContainer>
          <Typography color="textSecondary">{texts.noContractMessage}</Typography>
        </EmptyStateContainer>
      ) : (
        <ContractEditor showPostCommitmentConfiguration={showPostCommitmentConfiguration} />
      )}
      <LoadingOverlay isLoading={shouldShowBlockingLoader} />
    </StyledModalContent>
  );
};

LeadModalContract.propTypes = {
  lead: PropTypes.object.isRequired,
  showPostCommitmentConfiguration: PropTypes.bool,
  isSDRChat: PropTypes.bool,
};

LeadModalContract.defaultProps = {
  showPostCommitmentConfiguration: false,
  isSDRChat: false,
};

export default LeadModalContract;
